<template>
	<div class="store-outlets-section">
		<div class="scroll-section1">
			<img src="images/store-outlets-scroll-section1-pc-01.png" alt="">
		</div>
		<div class="scroll-section2">
			<div class="section">
				<div :class="{item: true, active: type == 1}" v-on:click="typeChangeFun(1, 'anchorPoint1')">护工来啦门店</div>
				<div :class="{item: true, active: type == 2}" v-on:click="typeChangeFun(2, 'anchorPoint2')">服务内容</div>
				<div :class="{item: true, active: type == 3}" v-on:click="typeChangeFun(3, 'anchorPoint3')">网点分布</div>
				<div :class="{item: true, active: type == 4}" v-on:click="typeChangeFun(4, 'anchorPoint4')">合作加盟</div>
			</div>
		</div>
		<div id="anchorPoint1"></div>
		<div class="scroll-section3">
			<h1>护工来啦门店</h1>
			<div class="section">
				<p>护工来啦门店以平台为基础，同时专注于提供养老规划、社区健康管理咨询、慢病管理、辅具租赁等公益为老服务。最终线上、线下互补共赢，形成一个良好的生态圈。以护理为核心刚需，除此以外全面了解老人其他的需求，认真分析老人的需求点，做好相关服务的精准匹配。</p>
				<p>提供相关服务，如代配药服务、理疗服务、外出旅游、疗养、房屋出租等，做到“一站式”服务，全方面满足老人的各种需求。</p>
			</div>
			<div class="footer">
				<div class="item">
					<img src="images/store-outlets-scroll-section2-mobile-01.jpg" alt="">
				</div>
				<div class="item">
					<img src="images/store-outlets-scroll-section2-mobile-02.jpg" alt="">
				</div>
				<div class="item">
					<img src="images/store-outlets-scroll-section2-mobile-03.jpg" alt="">
				</div>
				<div class="item">
					<img src="images/store-outlets-scroll-section2-mobile-04.jpg" alt="">
				</div>
			</div>
		</div>
		<div id="anchorPoint2"></div>
		<div class="scroll-section4">
			<div class="section">
				<h1>服务内容</h1>
				<div class="section">
					<div class="item">
						<div>护理</div>
						<div>服务</div>
					</div>
					<div class="item">
						<div>陪诊</div>
						<div>代配药</div>
					</div>
					<div class="item">
						<div>社区健康</div>
						<div>管理咨询</div>
					</div>
					<div class="item">
						<div>慢病</div>
						<div>管理</div>
					</div>
					<div class="item">
						<div>辅具</div>
						<div>租赁</div>
					</div>
				</div>
			</div>
		</div>
		<div id="anchorPoint3"></div>
		<div class="scroll-section5">
			<h1>网点分布</h1>
			<div id="allmap" class="section"></div>
		</div>
		<div id="anchorPoint4"></div>
		<div class="scroll-section6">
			<h1>加盟合作</h1>
			<h2>依托平台资源，使护工不再难找，生意不再难做，咨询热线：400-600-5055</h2>
		</div>
	</div>
</template>

<script>
	export default{
		name: "StoreOutletsPC",
		data(){
			return {
				type: 1
			}
		},
		methods:{
			typeChangeFun (value, domeId){
				this.type = value;
				var scrollTop = document.getElementById(domeId).offsetTop;
				util.scrollTo(scrollTop);
			}
		},mounted() {
			let map = new BMap.Map("allmap");    // 创建Map实例
			let point = new BMap.Point(121.605455, 31.142041);
			map.centerAndZoom(point, 12);  // 初始化地图,设置中心点坐标和地图级别
			//添加地图类型控件
			map.setCurrentCity("上海");          // 设置地图显示的城市 此项是必须设置的
			map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
			// 编写自定义函数,创建标注
			function addMarker(point, content){
				var marker = new BMap.Marker(point);
				map.addOverlay(marker);
				marker.addEventListener("click", function (e) {
					var point = new BMap.Point(e.target.getPosition().lng, e.target.getPosition().lat);
					var infoWindow = new BMap.InfoWindow(content, {
                        width: 250, // 信息窗口宽度
                        height: 90, // 信息窗口高度
                        title: "", // 信息窗口标题
                        enableMessage: true //设置允许信息窗发送短息
                    }); // 创建信息窗口对象
					map.openInfoWindow(infoWindow, point); //开启信息窗口
				});
			}
			// 向地图添加门店
			let storeList = [{
				lng: 121.563957,
				lat: 31.186869,
				content: `
					<div>
						<h2 style="margin: auto">护工来啦北蔡店</h2>
						<p style="margin: 8px auto 4px auto">上海浦东新区莲安东路92号</p>
						<p style="margin: auto">021-68909615</p>
					</div>
				`
			},{
				lng: 121.522141,
				lat: 31.216907,
				content: `
					<div>
						<h2 style="margin: auto">护工来啦塘桥店</h2>
						<p style="margin: 8px auto 4px auto">上海市浦东新区塘桥新路195号 </p>
						<p style="margin: auto">13524178365</p>
					</div>
				`
			},{
				lng: 121.763506,
				lat: 31.05454,
				content: `
					<div>
						<h2 style="margin: auto">护工来啦惠南店</h2>
						<p style="margin: 8px auto 4px auto">上海市浦东新区惠南镇人民东路3300号</p>
						<p style="margin: auto">13022111171</p>
					</div>
				`
			}]
			for (let i = 0; i < storeList.length; i ++) {
				let point = new BMap.Point(storeList[i].lng, storeList[i].lat);
				addMarker(point, storeList[i].content);
			}
		}
	}
</script>

<style scoped="scoped">
	.scroll-section1{
		width: 100%;
	}
	.scroll-section1>img{
		width: 100%;
		display: block;
	}
	.scroll-section2{
		width: 100%;
		height: 0.6rem;
		background: #F4F4F4;
	}
	.scroll-section2>.section{
		width: 100%;
		height: 100%;
		max-width: 9.6rem;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		box-sizing: border-box;
		position: relative;
	}
	.scroll-section2>.section>.item{
		flex-shrink: 0;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 0.6rem;
		font-size:0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.5;
		color: #333333;
		text-decoration: none;
		border-bottom: 0.04rem solid transparent;
		box-sizing: border-box;
		cursor: pointer;
	}
	.scroll-section2>.section>.item.active{
		border-color: #4788F4;
	}
	.scroll-section2>.section>.item:nth-of-type(1){
		margin-left: 0;
	}
	.scroll-section3,
	.scroll-section4,
	.scroll-section5,
	.scroll-section6{
		width: 9.6rem;
		margin: 0.86rem auto 0 auto;
	}
	.scroll-section3>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color: #333333;
	}
	.scroll-section3>.section{
		margin-top: 0.4rem;
	}
	.scroll-section3>.section>p{
		font-size: 0.18rem;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height: 1.6;
		color: #666666;
		margin: 0.1rem 0 0 0;
	}
	.scroll-section3>.footer{
		margin-top: 0.28rem;
		display: flex;
		flex-wrap: wrap;
	}
	.scroll-section3>.footer>.item{
		margin: 0.16rem 0 0 0.16rem;
		width: 40%;
		flex: 1 0 auto;
	}
	.scroll-section3>.footer>.item:nth-of-type(2n+1){
		margin-left: 0;
	}
	.scroll-section3>.footer>.item:nth-of-type(1),
	.scroll-section3>.footer>.item:nth-of-type(2){
		margin-top: 0;
	}
	.scroll-section3>.footer>.item>img{
		display: block;
		width: 100%;
	}
	.scroll-section4{
		width: 12rem;
		padding: 0.6rem 1.2rem;
		box-sizing: border-box;
		background-color: #F4F4F4;
	}
	.scroll-section4>.section{
		width: 9.6rem;
		margin: 0 auto;
	}
	.scroll-section4>.section>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color: #4788F4;
	}
	.scroll-section4>.section>.section{
		margin-top: 0.36rem;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.scroll-section4>.section>.section>.item{
		width: 1px;
		flex: 1 0 auto;
		font-size:0.22rem;
		font-family:Microsoft YaHei;
		font-weight:bold;
		line-height: 1.6;
		color: #4788F4;
		text-align: center;
		border-left: 0.02rem solid #4788F4;
	}
	.scroll-section4>.section>.section>.item:nth-of-type(1){
		border-left-color: transparent;
	}
	.scroll-section5>h1{
		font-size:0.3rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
	}
	.scroll-section5>.section{
		width:100%;
		height:6.2rem;
	}
	.scroll-section6{
		width: 100%;
		background: #4788F4;
		padding: 0.64rem 1.2rem;
		box-sizing: border-box;
	}
	.scroll-section6>h1{
		font-size: 0.36rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color: #FFFFFF;
		text-align: center;
		margin: auto;
	}
	.scroll-section6>h2{
		margin: 0.16rem auto auto auto;
		font-size: 0.32rem;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.6;
		color: #FFFFFF;
		text-align: center;
	}
</style>